import axios from "@/plugins/axiosInstance";
import { googleIntegration } from "@/networking/urlManager";
import { responseHandlerService } from "@/plugins/responseHandlerService";

export async function checkGoogleAuth(assetId) {
  try {
    const googleResponse = await axios.get(googleIntegration.checkAuth, {
      params: {
        assetId: assetId,
      },
    });

    // Google entegrasyon durumunu döndür
    if (googleResponse.data && googleResponse.data.data) {
      return {
        isConnected: googleResponse.data.data.isConnected,
        error: null,
      };
    } else {
      return {
        isConnected: false,
        error: null,
      };
    }
  } catch (error) {
    responseHandlerService.handleError(error);
    return {
      isConnected: false,
      error: error,
    };
  }
}
